<template>
  <div class="active-schools">
    <h1 class="text-center my-7">پورتال ها</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <Navigation />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-card class="elevation-0 mb-5 pa-5">
          <h5>اضافه کردن پورتال جدید</h5>
          <v-alert v-if="alert" small outlined type="success" class="my-4">
            {{ alert }}
          </v-alert>
          <v-form
            v-model="valid"
            @submit.prevent="addPortal"
            class="text-center"
          >
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="name"
                  :rules="nameRules"
                  autocomplete="off"
                  label="نام پورتال"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="url"
                  :rules="urlRules"
                  autocomplete="off"
                  hint="فقط ساب دامین را بدون بدون www و http یا https وارد کنید"
                  label="ساب دامین پورتال"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="percentage"
                  :rules="percentageRules"
                  autocomplete="off"
                  label="درصد سهم پورتال"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="address"
                  :rules="addressRules"
                  autocomplete="off"
                  hint="آدرس مدرسه را به همراه استان و شهرستان تایپ نمایید"
                  label="آدرس مدرسه"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="tel"
                  :rules="telRules"
                  autocomplete="off"
                  hint="شماره تلفن را بدون خط تیره و همراه با کد شهر وارد نمایید"
                  label="تلفن تماس مدرسه"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="title"
                  :rules="titleRules"
                  autocomplete="off"
                  label="نام صفحه اصلی"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="description"
                  :rules="descriptionRules"
                  autocomplete="off"
                  label="توضیحات"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  id="pStartDate"
                  label="تاریخ شروع"
                  v-model="pStartDate"
                  :rules="pStartDateRules"
                  hide-details="auto"
                />
                <date-picker
                  v-model="pStartDate"
                  :rules="pStartDateRules"
                  :auto-submit="true"
                  format="jYYYY/jMM/jDD"
                  element="pStartDate"
                  alt-name="startDate"
                  alt-format="YYYY-MM-DD HH:mm:ss"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  id="pEndDate"
                  label="تاریخ پایان"
                  v-model="pEndDate"
                  :rules="pEndDateRules"
                  hide-details="auto"
                />
                <date-picker
                  v-model="pEndDate"
                  :rules="pStartDateRules"
                  :auto-submit="true"
                  format="jYYYY/jMM/jDD"
                  element="pEndDate"
                  alt-name="endDate"
                  alt-format="YYYY-MM-DD HH:mm:ss"
                />
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <v-text-field
                    v-model="mobile"
                    :rules="mobileRules"
                    autocomplete="off"
                    label="تلفن همراه رابط"
                  ></v-text-field>
                  <v-btn
                    :loading="loading"
                    :disabled="loading || !mobile"
                    depressed
                    color="primary"
                    class="mr-2"
                    @click="searchUser()"
                  >
                    جستجوی کاربر
                  </v-btn>
                  <div v-if="user" class="flex-fill mr-2">
                    <span small>شماره همراه:</span>
                    <v-chip small class="mx-1">{{ user.username }}</v-chip>
                    <span small>رابط:</span>
                    <v-chip small class="mx-1">
                      {{ user.firstname }} {{ user.lastname }}
                    </v-chip>
                    <span small>نوع کاربر:</span>
                    <v-chip small class="mx-1">
                      {{ user.type }}
                    </v-chip>
                    <v-alert
                      v-if="user.type != 'دانش آموز'"
                      outlined
                      dense
                      small
                      type="error"
                      class="mt-2"
                    >
                      کاربر نباید دسترسی دیگری داشته باشد تا بتواند رابط پورتال
                      باشد
                    </v-alert>
                  </div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-btn
                  :loading="loading"
                  :disabled="
                    !valid || loading || !user || user.type != 'دانش آموز'
                  "
                  depressed
                  block
                  color="primary"
                  type="submit"
                >
                  ارسال درخواست
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
        <h3 class="mb-5">لیست نمایندگی ها</h3>
        <v-data-table
          :headers="headers"
          :items="portals"
          :items-per-page="10"
          show-expand
          single-expand
          item-key="_id"
        >
          <template v-slot:[`item.url`]="{ item }">
            <v-btn outlined depressed small color="success" :href="item.url">
              {{ item.url }}<v-icon small class="mr-2">mdi-earth</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.startDate`]="{ item }">
            <persian-date :date="item.startDate" />
          </template>
          <template v-slot:[`item.endDate`]="{ item }">
            <persian-date
              :class="dateCheck(item.endDate) ? 'error--text' : ''"
              :date="item.endDate"
            />
            <div small class="error--text" v-if="dateCheck(item.endDate)">
              زمان این پورتال به اتمام رسیده است
            </div>
          </template>
          <template v-slot:[`item._id`]="{ item }">
            <v-btn
              fab
              plain
              x-small
              router
              :to="{ name: 'SummeryPortal', params: { id: item._id } }"
            >
              <v-icon>mdi-cash</v-icon>
            </v-btn>

            <v-btn
              fab
              plain
              x-small
              router
              :to="{ name: 'EditPortal', params: { id: item._id } }"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>

            <v-btn
              fab
              plain
              x-small
              @click="activePortal(item._id, !item.enable)"
            >
              <v-icon v-if="item.enable"
                >mdi-checkbox-marked-circle-outline</v-icon
              >
              <v-icon v-else>mdi-cancel</v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div class="d-flex align-center">
                <span class="ml-3">رابط:</span>
                <v-chip>
                  {{ item.user.firstname }} {{ item.user.lastname }} -
                  {{ item.user.username }}
                </v-chip>
                <span class="mx-3">توضیحات:</span>
                <v-chip>{{ item.description }}</v-chip>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Navigation from "../_Navigation.vue";
export default {
  name: "portals-component",
  components: {
    Navigation
  },
  data: () => {
    return {
      valid: true,
      loading: false,
      alert: null,
      portals: [],
      headers: [
        { text: "نام پورتال", value: "name", align: "center" },
        { text: "آدرس", value: "url", align: "center" },
        { text: "درصد سهم", value: "percentage", align: "center" },
        { text: "تاریخ ایجاد", value: "startDate", align: "center" },
        { text: "تاریخ اتمام", value: "endDate", align: "center" },
        { text: "اقدامات", value: "_id", align: "center" }
      ],
      name: "",
      nameRules: [(v) => !!v || "وارد کردن نام پورتال اجباری است"],
      title: "",
      titleRules: [(v) => !!v || "وارد کردن نام صفحه اصلی پورتال اجباری است"],
      url: "",
      urlRules: [(v) => !!v || "وارد کردن آدرس پورتال اجباری است"],
      address: "",
      addressRules: [(v) => !!v || "وارد کردن آدرس پورتال اجباری است"],
      tel: "",
      telRules: [(v) => !!v || "وارد کردن آدرس پورتال اجباری است"],
      percentage: 15,
      percentageRules: [(v) => !!v || "وارد کردن درصد سهم پورتال اجباری است"],
      description: "",
      descriptionRules: [
        (v) => !!v || "وارد کردتوضیحات برای پورتال اجباری است"
      ],
      pStartDate: "",
      pStartDateRules: [
        (v) => !!v || "وارد کردن تاریخ شروع برای پورتال اجباری است"
      ],
      pEndDate: "",
      pEndDateRules: [
        (v) => !!v || "وارد کردن تاریخ پایان برای پورتال اجباری است"
      ],
      mobile: "",
      mobileRules: [
        (v) => !!v || "وارد شماره تلفن کاربر رابط برای پورتال اجباری است"
      ],
      user: null,
      pUpdateEndDate: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api
        .get("/portals")
        .then((res) => {
          this.portals = res.data.portals;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dateCheck(date) {
      return date < new Date().toISOString();
    },
    searchUser() {
      this.loading = true;
      this.$api
        .post("/user/getbymobile", {
          mobile: this.mobile
        })
        .then((res) => {
          this.user = res.data.user;
          this.loading = false;
        });
    },
    addPortal() {
      this.loading = true;
      const startDate = document.getElementsByName("startDate")[0].value;
      const endDate = document.getElementsByName("endDate")[0].value;
      this.$api
        .post("/portal/add", {
          name: this.name,
          title: this.title,
          description: this.description,
          address: this.address,
          tel: this.tel,
          percentage: this.percentage,
          url: "https://" + this.url + ".pirls.ir",
          startDate: startDate,
          endDate: endDate,
          user: this.user._id
        })
        .then(() => {
          this.alert = "پورتال با موفقیت اضافه گردید";
          this.getData();
          this.loading = false;
        });
    },
    activePortal(id, staus) {
      this.loading = true;
      this.$api
        .post("/portal/active", {
          id: id,
          staus: staus
        })
        .then((res) => {
          this.portals = res.data.portals;
          this.loading = false;
        });
    }
  }
};
</script>
